import { render, staticRenderFns } from "./AppEditor.vue?vue&type=template&id=be0a3340&lang=pug"
import script from "./AppEditor.vue?vue&type=script&lang=js"
export * from "./AppEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports